<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <span v-html="title"></span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          <span v-html="description"></span>
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="close">Annuleren</button>
        <button type="button" class="btn btn-primary" @click="buttonClick" id="confirm-modal">{{ buttonSave }}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    callback: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonSave: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    buttonClick() {
      this.callback()
      this.close()
    },
  },
}

</script>

<style>

.ConfirmAction .modal-title, .ConfirmAction b {
  color: rgb(37,44,59) !important;
}

</style>

<style scoped>

.modal-dialog {
  flex-basis: 400px;
  margin: 0 12px;
  font-size: 15px !important;
}
.modal-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.modal-title {
  font-size: 0.95em ;
}
p {
  color: rgb(130,130,130);
}

</style>
